module.exports = __webpack_public_path__ + "img/30_21.e2d9e0dc.png";